/**
 * Gera um UUID v4
 */
export function generateId(): string {
    return crypto.randomUUID();
}

/**
 * Formata data para exibição
 */
export function formatDate(date: string | Date, options?: Intl.DateTimeFormatOptions): string {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString('pt-BR', options || {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}

/**
 * Formata data e hora
 */
export function formatDateTime(date: string | Date): string {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

/**
 * Formata número como porcentagem
 */
export function formatPercent(value: number, decimals: number = 1): string {
    return `${value.toFixed(decimals)}%`;
}

/**
 * Merge de classes CSS (tipo clsx)
 */
export function classNames(...classes: (string | undefined | null | false)[]): string {
    return classes.filter(Boolean).join(' ');
}

/**
 * Calcula porcentagem de compliance
 */
export function calculateCompliance(
    measurements: { measuredShare: number; targetShare: number }[]
): number {
    if (measurements.length === 0) return 0;

    const compliant = measurements.filter(m => m.measuredShare >= m.targetShare);
    return (compliant.length / measurements.length) * 100;
}

/**
 * Calcula cor de status baseado em porcentagem
 */
export function getComplianceColor(percent: number): 'success' | 'warning' | 'danger' {
    if (percent >= 85) return 'success';
    if (percent >= 70) return 'warning';
    return 'danger';
}

/**
 * Debounce function
 */
export function debounce<T extends (...args: unknown[]) => unknown>(
    fn: T,
    delay: number
): (...args: Parameters<T>) => void {
    let timeoutId: ReturnType<typeof setTimeout>;

    return (...args: Parameters<T>) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn(...args), delay);
    };
}

/**
 * Sleep/delay
 */
export function sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Trunca texto com ellipsis
 */
export function truncate(text: string, maxLength: number): string {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength - 3) + '...';
}

/**
 * Capitaliza primeira letra
 */
export function capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}
